export function pushAddToWishlistEvent(data, pageType) {
  window.dataLayer.push({
    productSku: data.sku,
    productPrice: data.price,
    productBrand: data.brand,
    productCategory: data.category,
    event: 'addToWL',
    dimension65: pageType
  });
}

export function pushRemoveFromWishlistEvent(data, pageType) {
  window.dataLayer.push({
    productSku: data.sku,
    productPrice: data.price,
    event: 'removeFromWL',
    dimension65: pageType
  });
}



/** WEBPACK FOOTER **
 ** ./legacy/home24-desktop/tracking/wishlist/baseWishlistButtonEvents.js
 **/